import type { IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { IGetCollectionTriageNextResponse } from '../getCollectionTriageNext/get-collection-triage-next-response';
import { getCollectionTriageNextResponseSchema } from '../getCollectionTriageNext/get-collection-triage-next-response';
import type { IGetCollectionTriageClipRequest } from './get-collection-triage-clip-request';

/**
 * @deprecated Superseded by `getCollectionTriageClipV3Api`. Frozen, not deleted -
 * an old app binary may still call it. See "Web-only / orphan versions pending
 * deletion" in apps/api/CLAUDE.md.
 */
export async function getCollectionTriageClipApi({
  collectionId,
  clipId,
}: IGetCollectionTriageClipRequest): Promise<IValidatedResponse<IGetCollectionTriageNextResponse>> {
  return getRequest<IGetCollectionTriageNextResponse>({
    path: `/sys/collections/${collectionId}/triage/clip?clipId=${clipId}`,
    schema: getCollectionTriageNextResponseSchema,
  });
}
